import { Koi } from '@ksyos/koi';
import { emailSchema } from '../schemas/emailSchema';

export const pilotExaminationV1FinalRequest = Koi.object().keys({
    emailadres: emailSchema.allow(null),
    indicatie: Koi.string().max(10000).allow(null),
    toelichting: Koi.string().max(10000).allow(null),
});

export const pilotReferralSmallV1FinalRequest = Koi.object().keys({
    co_morbiditeiten: Koi.string().max(10000).allow(null),
    emailadres: emailSchema.allow(null),
    toelichting: Koi.string().max(10000).allow(null),
    verwijsreden: Koi.string().max(10000).allow(null),
    voorgeschiedenis: Koi.string().max(10000).allow(null),
});

export const pilotExaminationV1FinalProcedure = Koi.object().keys({
    anamnese: Koi.string().max(10000).allow(null),
    emailadres: emailSchema.allow(null),
    metingen: Koi.string().max(10000).allow(null),
    toelichting: Koi.string().max(10000).allow(null),
});

export const pilotContactV1FinalRequest = Koi.object().keys({
    anamnese: Koi.string().max(10000).allow(null),
    beleid: Koi.string().max(10000).allow(null),
    diagnose: Koi.string().max(10000).allow(null),
    onderzoek: Koi.string().max(10000).allow(null),
});

export const pilotConsultationV1FinalRequest = Koi.object().keys({
    emailadres: emailSchema.allow(null),
    toelichting: Koi.string().max(10000).allow(null),
    vraag: Koi.string().max(10000).allow(null),
    werkdiagnose: Koi.string().max(10000).allow(null),
});

export const pilotExaminationV1FinalDiagnosticReport = Koi.object().keys({
    afwijkend: Koi.string().valid('Ja', 'Nee', 'Niet te beoordelen', null),
    toelichting_bevindingen: Koi.string().max(10000).allow(null),
    werkdiagnose: Koi.string().max(10000).allow(null),
});

export const pilotConsultationV1FinalDiagnosticReport = Koi.object().keys({
    beleid: Koi.string().max(10000).allow(null),
    bevindingen: Koi.string().max(10000).allow(null),
    toelichting_bevindingen: Koi.string().max(10000).allow(null),
    werkdiagnose: Koi.string().max(10000).allow(null),
});

export const pilotReferralV1FinalRequest = Koi.object().keys({
    co_morbiditeiten: Koi.string().max(10000).allow(null),
    emailadres: emailSchema.allow(null),
    toelichting: Koi.string().max(10000).allow(null),
    verwijsreden: Koi.string().max(10000).allow(null),
    voorgeschiedenis: Koi.string().max(10000).allow(null),
});

export const pilotV1IntakeReport = Koi.object().keys({
    intake: Koi.string().max(100000).allow(null),
});

export const pilotV1DischargeReport = Koi.object().keys({
    dischargeLetter: Koi.string().max(100000).allow(null),
});

export const pilotExaminationV1FinalSupervision = Koi.object().keys({
    afwijkend: Koi.string().valid('Ja', 'Nee', 'Niet te beoordelen', null),
});
